<script setup lang="ts">
const store = usePortfolioStore()
const p = store.profile
</script>

<template>
  <footer data-reveal
          class="relative flex flex-wrap items-center justify-between gap-3.5 overflow-hidden rounded-[28px]
                 px-5 py-4.5 shadow-[var(--t-clay)] [background:var(--t-footer4)]">
    <div class="flex min-w-0 items-center gap-3.5">
      <span data-decor="true" class="grid h-[52px] w-[52px] shrink-0 place-content-center rounded-[18px] bg-gradient-to-b from-[#f8d888] to-[#f0bf55]
                   shadow-[inset_0_3px_4px_rgb(255_255_255/0.6),inset_0_-4px_6px_rgb(180_120_30/0.35),0_8px_16px_rgb(60_30_130/0.3)]
                   [animation:floatY_5s_ease-in-out_infinite]">
        <svg viewBox="0 0 24 24" class="h-[27px] w-[27px] drop-shadow-[0_1.5px_1px_rgb(180_120_30/0.4)]" fill="#fff"><path d="M12 2.6c.4 0 .7.2.9.6l2.4 4.9 5.4.8c.9.1 1.2 1.2.6 1.8l-3.9 3.8.9 5.4c.2.9-.8 1.5-1.6 1.1L12 18.4 7.3 21c-.8.4-1.8-.2-1.6-1.1l.9-5.4-3.9-3.8c-.6-.6-.3-1.7.6-1.8l5.4-.8 2.4-4.9c.2-.4.5-.6.9-.6z" /></svg>
      </span>
      <div class="min-w-0">
        <p class="flex items-center gap-1.5 text-[14.5px] font-extrabold text-white">بیایید با هم کار کنیم
          <svg viewBox="0 0 24 24" class="h-[15px] w-[15px] drop-shadow-[0_1.5px_1px_rgb(60_30_130/0.35)]" fill="#f8d888"><path d="M12 2.5l2.1 5.9 5.9 2.1-5.9 2.1L12 18.5l-2.1-5.9L4 10.5l5.9-2.1L12 2.5zM19 16l1 2.5L22.5 19 20 20l-1 2.5L18 20l-2.5-1 2.5-.5L19 16z" /></svg>
        </p>
        <p class="mt-1 text-[11.5px] text-white/85">{{ p.email || p.contact?.email }} · {{ p.phone || p.contact?.phone }} · {{ p.location || p.contact?.city }}</p>
        <p class="mt-1 text-[10.5px] text-white/65">© ۱۴۰۴ {{ p.fullname || p.name }} — حق طراحی محفوظ است.</p>
      </div>
    </div>
    <a v-if="p.email || p.contact?.email" :href="'mailto:' + (p.email || p.contact.email)"
       class="shrink-0 rounded-full px-6 py-2.5 text-[12.5px] font-extrabold text-white [background:var(--t-footer-btn4)]
              shadow-[0_8px_18px_rgb(60_30_130/0.35),inset_0_2px_3px_rgb(255_255_255/0.45),inset_0_-3px_5px_rgb(60_30_130/0.3)]
              transition duration-300 hover:-translate-y-0.5 hover:scale-[1.03] hover:brightness-107">تماس با من</a>
  </footer>
</template>
